import { createSlice } from '@reduxjs/toolkit';

export interface DesignSchedule {
  sowFinalized: string;
  schematicSet: string;
  developmentDocumentSet: string;
  constructionDocumentSet: string;
  permitsObtained: string;
}

const initialState: DesignSchedule = {
  sowFinalized: '',
  schematicSet: '',
  developmentDocumentSet: '',
  constructionDocumentSet: '',
  permitsObtained: '',
};

export const DesignScheduleSlice = createSlice({
  name: 'designScheduleSliceInfo',
  initialState,
  reducers: {
    setDesignSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setDesignSchedule } = DesignScheduleSlice.actions;

export default DesignScheduleSlice.reducer;
